import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  /** Define all env vars in `runtimeEnv`, then define schema in either `client` or
   * `server`. */
  runtimeEnv: {
    NEXT_PUBLIC_STRIPE_KEY_DEV: process.env.NEXT_PUBLIC_STRIPE_KEY_DEV,
    NEXT_PUBLIC_STRIPE_KEY_DEV2: process.env.NEXT_PUBLIC_STRIPE_KEY_DEV2,
    NEXT_PUBLIC_STRIPE_KEY_LATAM: process.env.NEXT_PUBLIC_STRIPE_KEY_LATAM,
    NEXT_PUBLIC_STRIPE_KEY_PM_LATAM:
      process.env.NEXT_PUBLIC_STRIPE_KEY_PM_LATAM,
    NEXT_PUBLIC_STRIPE_KEY_EMEA: process.env.NEXT_PUBLIC_STRIPE_KEY_EMEA,
    NEXT_PUBLIC_BASE_URL_DEALER_APP:
      process.env.NEXT_PUBLIC_BASE_URL_DEALER_APP,
    NEXT_PUBLIC_SITE_SERVICES_URL: process.env.NEXT_PUBLIC_SITE_SERVICES_URL,
    NEXT_PUBLIC_OKTA_ORG_URL: process.env.NEXT_PUBLIC_OKTA_ORG_URL,
    NEXT_PUBLIC_NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV,
    AUTH_OKTA_ISSUER: process.env.AUTH_OKTA_ISSUER,
    OKTA_CLIENT_ID_DEALER_APP: process.env.OKTA_CLIENT_ID_DEALER_APP,
  },
  client: {
    NEXT_PUBLIC_STRIPE_KEY_DEV: z.string().min(1),
    NEXT_PUBLIC_STRIPE_KEY_DEV2: z.string().min(1),
    NEXT_PUBLIC_STRIPE_KEY_LATAM: z.string().min(1),
    NEXT_PUBLIC_STRIPE_KEY_PM_LATAM: z.string().min(1),
    NEXT_PUBLIC_STRIPE_KEY_EMEA: z.string().min(1),
    NEXT_PUBLIC_BASE_URL_DEALER_APP: z.string(),
    NEXT_PUBLIC_SITE_SERVICES_URL: z.string(),
    NEXT_PUBLIC_OKTA_ORG_URL: z.string(),
    NEXT_PUBLIC_NODE_ENV: z.enum([
      'development',
      'test',
      'staging',
      'production',
    ]),
  },
  server: {
    AUTH_OKTA_ISSUER: z.string().min(1),
    OKTA_CLIENT_ID_DEALER_APP: z.string().min(1),
  },
  emptyStringAsUndefined: true,
});
